import React from 'react'
import ComponentLogo from '../Components/ComponentLogo'
import BarraSecundaria from '../Components/BarraSecundaria'
import Contactenos from '../Components/Contactenos'
import ProductosCategorias from '../Components/ProductosCategorias'

const inicio = () => {
  return (
    <>
        <ComponentLogo/>
        <BarraSecundaria/>
        <ProductosCategorias/>
        <Contactenos/>
    </>
  )
}

export default inicio